(() => {
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-sale-variant]');
    if (!select) return;
    const card = select.closest('[data-sale-card]');
    const option = select.selectedOptions[0];
    if (!card || !option.value) return;
    card.querySelector('[data-sale-price]').textContent = option.dataset.price;
    const was = card.querySelector('[data-sale-was]');
    was.textContent = option.dataset.was;
    was.hidden = !option.dataset.was;
    const discount = card.querySelector('[data-sale-discount]');
    discount.textContent = option.dataset.discount;
    discount.hidden = !option.dataset.discount;
  });
  async function loadBest(section) {
    if (section.dataset.loaded) return;
    section.dataset.loaded = 'true';
    try {
      const url = new URL(section.dataset.saleUrl, location.origin);
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      const response = await fetch(url, { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('Collection section unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const grid = doc.querySelector('[data-sale-best-grid]');
      if (grid && grid.querySelector('[data-sale-card]')) section.querySelector('[data-sale-best-grid]').replaceChildren(...grid.childNodes);
    } catch (_) { section.dataset.loaded = 'failed'; }
  }
  function init(root = document) {
    root.querySelectorAll('[data-sale-bestsellers]').forEach(section => {
      if (!('IntersectionObserver' in window)) { loadBest(section); return; }
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) { loadBest(section); observer.disconnect(); }
      }, { rootMargin: '900px' });
      observer.observe(section);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true});
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
